class ContentNav {
    /**
     * @param root {HTMLElement}
     */
    constructor(root) {
        this.root = root

        this.initialize()
    }

    initialize() {
        this.toggle = this.root.querySelector('[data-component-part="toggle"]')
        this.toggle.addEventListener('click', () => {
            if (this.isOpen()) {
                this.close()
            } else {
                this.open()
            }
        })

        /** @type {Object<string, IntersectionObserver>} */
        this.intersectionObservers = {}
        /** @type {Object<string, {id: string, element: HTMLElement|Element, previous: Object|null, next: Object|null, visible: boolean}>} */
        this.sections = {}

        let previousSection = null
        this.root.querySelectorAll('[data-component-part="sectionLink"]').forEach(sectionLink => {
            const id = sectionLink.getAttribute('href').substr(1)
            const section = document.querySelector('#' + id)
            if (section) {
                this.sections[id] = {
                    id: id,
                    element: section,
                    previous: previousSection,
                    next: null,
                    visible: false
                }
                if (previousSection) {
                    this.sections[previousSection.id].next = this.sections[id]
                }
                previousSection = this.sections[id]
            }
        })
        window.addEventListener('resize', () => {
            this.initializeIntersectionObserver()
        })

        this.initializeIntersectionObserver()
    }

    initializeIntersectionObserver() {
        // Clear existing observers
        for (const id in this.intersectionObservers) {
            if (Object.hasOwnProperty.call(this.intersectionObservers, id)) {
                const observer = this.intersectionObservers[id]
                observer.disconnect()
                delete this.intersectionObservers[id]
            }
        }

        const threshold = 0.5
        for (const id in this.sections) {
            if (Object.hasOwnProperty.call(this.sections, id)) {
                const section = this.sections[id]
                const sectionElement = section.element
                let elementThreshold = threshold
                const elementHeight = sectionElement.getBoundingClientRect().height
                if (elementHeight > window.innerHeight * threshold) {
                    elementThreshold = ((window.innerHeight * threshold) / elementHeight) * threshold
                }
                this.intersectionObservers[id] = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        this.sections[entry.target.getAttribute('id')].visible = entry.isIntersecting
                    })
                    this.updateVisible()
                }, {
                    threshold: [elementThreshold, 1 - elementThreshold]
                })
                this.intersectionObservers[id].observe(sectionElement)
            }
        }
    }

    updateVisible() {
        for (const id in this.sections) {
            if (Object.hasOwnProperty.call(this.sections, id)) {
                const section = this.sections[id]
                if (section.visible && (!section.next || !(section.previous ? section.previous.visible : false))) {
                    this.root.querySelectorAll('[data-component-part="sectionLink"]').forEach(sectionLink => {
                        sectionLink.parentElement.classList.remove('is-active')
                    })
                    this.root.querySelector('[data-component-part="sectionLink"][href="#' + section.id + '"]').parentElement.classList.add('is-active')
                }
            }
        }
    }

    open() {
        this.root.classList.add('is-open')
    }

    close() {
        this.root.classList.remove('is-open')
    }

    isOpen() {
        return this.root.classList.contains('is-open')
    }
}

export { ContentNav }
